<div id="cards-container" fxLayout="column" fxFill>
  <div class="searchBox" fxLayout="row" fxLayoutGap="5px">
    <mat-icon svgIcon="search"></mat-icon>
    <input
      id="search-box"
      class="search-box"
      [placeholder]="res('Search') + '...'"
      [(ngModel)]="searchText"
      (input)="applyFilter(searchText)"
    />
    <mat-icon class="clear-search" svgIcon="clear" (click)="clearSearchInput()"></mat-icon>
  </div>
  <div fxFlex="calc(100% - 120px)" fxLayout="column" fxLayoutAlign=" stretch">
    <dx-scroll-view>
      <mat-icon
        [ngStyle]="{ visibility: displayArrowBack ? 'visible' : 'hidden' }"
        class="arrowBack"
        svgIcon="arrowBack"
        (click)="prevAction()"
      ></mat-icon>
      <div *ngIf="map?.size; else empty">
        <div *ngFor="let item of map | keyvalue; let index = index">
          <abcExpansionPanel
            #abcExpansionPanel
            *ngIf="isVisibleOrder(item.value[0].Order)"
            [style]="4"
            [multiple]="true"
            [selectedIndex]="index == 0 ? 0 : -1"
            (onOpen)="openExpansion($event, index)"
            [collapsible]="displayArrowBack ? true : false"
            [tooltip]="searchText ? currentFolder : item.value[0].Order?.DisplayText"
            [width]="'100%'"
            [height]="'auto'"
          >
            <div content="devExpress">
              <div fxLayout="row wrap" fxLayoutGap="15px grid">
                <abcCard
                  *ngFor="let obj of item.value"
                  fxFlex="50"
                  fxFlex.xs="100"
                  [class]="'card-style'"
                  id="{{ obj.DisplayText }}"
                  [leftIsImg]="false"
                  [leftIconPosition]="1"
                  [leftIconSize]="2"
                  [leftIconPath]="obj.Order?.LeftIconPath ?? obj.Order?.DisplayText"
                  displayText="{{ obj.DisplayText }}"
                  template="{{ obj.Template }}"
                  secondaryDisplayText="{{ obj.SecondaryDisplayText }}"
                  description="{{ obj.Description }}"
                  (onCardClick)="navigateTo(obj)"
                  (onCardDblClick)="primaryActionClick(obj)"
                  searchInput="{{ searchText }}"
                  [primaryActionName]="obj.PrimaryAction?.DisplayText"
                  (onPrimaryActionClick)="primaryActionClick(obj)"
                  secondaryActionName="{{ obj.SecondaryAction?.DisplayText }}"
                  (onSecondaryActionClick)="secondaryActionClick(obj)"
                >
                </abcCard>
              </div>
            </div>
          </abcExpansionPanel>
        </div>
      </div>
    </dx-scroll-view>
  </div>

  <div class="breadcrumbs">
    <mat-icon svgIcon="breadcrumbActive"></mat-icon>
    <mat-icon svgIcon="homeIcon" (click)="returnHomePage()"></mat-icon>
    <abc-tile-nav
      [dataSource]="tileNavMap | keyvalue"
      [activeStateEnabled]="true"
      [hoverStateEnabled]="true"
      [fillContent]="true"
      [offset]="70"
      (OnTileClick)="onTileClick($event)"
      class="bce-tile-nav"
    ></abc-tile-nav>
  </div>
  <ng-template #empty>
    <div class="empty" fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="20px">
      <mat-icon svgIcon="no-data-icon"></mat-icon>
      <div class="emptyMessage">{{ res('Empty-Message') }}</div>
    </div>
  </ng-template>
</div>
